import { memo } from 'react';

import { type SearchBoardsResponse } from '@air/api/types';
import { useCommandState } from '@air/cmdk';

import { SearchCommandBoardListItem } from '~/components/SearchCommand/SearchCommandBoardListItem';
import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';

export type SearchCommandBoardListProps = {
  boards: SearchBoardsResponse[];
  onBoardClick: (board: SearchBoardsResponse) => void;
};

export const SearchCommandBoardList = memo(({ boards, onBoardClick }: SearchCommandBoardListProps) => {
  const search = useCommandState((state) => state.search);

  return (
    <SearchCommandGroup heading={search ? 'Jump to' : 'Recent boards'}>
      {boards.map((board) => (
        <SearchCommandBoardListItem board={board} key={board.id} onSelect={onBoardClick} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandBoardList.displayName = 'SearchCommandBoardList';
